import Theme from '@refera/ui-core'

export const defaultToolbarOptions = {
  options: [
    'inline',
    'fontFamily',
    'fontSize',
    'blockType',
    'list',
    'textAlign',
    'colorPicker',
    'link',
  ],
  inline: {
    options: ['bold', 'italic', 'underline', 'strikethrough'],
  },
  fontFamily: {
    options: ['Roboto'],
  },
  fontSize: {
    options: [8, 9, 10, 11, 12, 14, 16, 18, 20, 24, 28, 32, 36, 48, 60, 72, 96],
  },
  colorPicker: {
    // get every color from the theme
    colors: Object.values(Theme.Colors).reduce((acc, value) => {
      Object.values(value).forEach(color => {
        acc.push(color)
      })
      return acc
    }, []),
  },
}
